import { useListingQuery } from './Listing.queries.generated';
import { ListingInclusion } from '../../../graphql.generated';
import { mapListingFragment, MappedListingFragment } from './mapListing';

export const useListing = (
    listingId: string,
    skip: boolean
): MappedListingFragment | null => {
    const { data } = useListingQuery({
        ssr: false,
        skip,
        variables: {
            listingId: parseInt(listingId, 10),
            include: [ListingInclusion.Expired]
        }
    });

    return data?.listingDetails?.__typename === 'ListingData'
        ? mapListingFragment(data.listingDetails)
        : null;
};
